import { ApolloError } from "shared/providers/apollo/apollo.package";
import { toast } from "shared/providers/toast/toast.package";

export const PERIOD_CLOSED_CODE = "PERIOD_CLOSED";

/**
 * Server message of a PERIOD_CLOSED refusal ("Books are closed through ..."),
 * or null for any other error
 */
export const getPeriodClosedMessage = (err: ApolloError): string | null =>
  err.graphQLErrors?.find(
    (gqlErr) => gqlErr.extensions?.code === PERIOD_CLOSED_CODE
  )?.message ?? null;

/**
 * Shows a PERIOD_CLOSED refusal as a toast that stays until dismissed, so the
 * reason isn't missed while the form stays open for a date fix.
 * Returns false for any other error so the caller can show its own toast.
 */
const handlePeriodClosedError = (err: ApolloError): boolean => {
  const message = getPeriodClosedMessage(err);

  if (!message) {
    return false;
  }

  toast.error(message, {
    toastId: "toast-period-closed",
    autoClose: false,
  });

  return true;
};

export default handlePeriodClosedError;
